import { type PaymentServiceType } from '@dni-types/data-models/ecommerce-payment'

export const PAYMENT_ERROR_CODE = {
  TAPPAY_SDK_NOT_LOADED: 'TAPPAY_SDK_NOT_LOADED',
  CHECKOUT_PAY_SDK_NOT_LOADED: 'CHECKOUT_PAY_SDK_NOT_LOADED',

  CONFIGURATION_FAILED: 'CONFIGURATION_FAILED',
  INVALID_PRIME: 'INVALID_PRIME',
  INVALID_PAYMENT_REQUEST: 'INVALID_PAYMENT_REQUEST',
  INVALID_APP_ID_OR_APP_KEY: 'INVALID_APP_ID_OR_APP_KEY',
  GET_PRIME_ERROR: 'GET_PRIME_ERROR',
}

export class PaymentError<Detail = unknown> extends Error {
  public service: PaymentServiceType
  public code: string | number
  public detail: Detail | undefined
  constructor(message: string, service: PaymentServiceType, code: string | number, detail?: Detail) {
    super(message)
    this.name = 'PaymentError'
    this.service = service
    this.code = code
    this.detail = detail
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PaymentError)
    }
  }
}
